import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { openSoundPillApp } from '../../utils/openSoundPillApp';
import './open-soundpill-page.css';

/** 카카오 공유·외부 링크용 — 앱 실행 후 미설치 시 스토어 이동 */
export default function OpenSoundPillPage() {
  useEffect(() => {
    openSoundPillApp('/app/home');
  }, []);

  return (
    <div className="open-soundpill-page">
      <Helmet>
        <title>사운드필 열기 | SoundPill</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <p className="open-soundpill-page__lead">사운드필 앱으로 이동 중이에요…</p>
      <p className="open-soundpill-page__sub">자동으로 이동하지 않으면 아래 버튼을 눌러 주세요.</p>
      <button type="button" className="open-soundpill-page__btn" onClick={() => openSoundPillApp('/app/home')}>
        사운드필 열기
      </button>
    </div>
  );
}
